module.exports = __webpack_public_path__ + "img/hr-sand-rock-medium-06.a120759e.png";